import React from 'react'
import { isMobile } from 'react-device-detect'
import { Motif } from '../../types/motifs'
import { ImageWrapper } from './styled'
import MotifSelector from './MotifSelector'

interface Props {
  motif: Motif
}

const MotifImageSection = ({ motif }: Props) => {
  return (
    <ImageWrapper>
      {motif.vectorizedUrl && <img src={motif.vectorizedUrl} alt={motif.title} />}
      {isMobile && window.innerHeight < 600 ? null : <MotifSelector motif={motif} />}
    </ImageWrapper>
  )
}

export default MotifImageSection
